document.addEventListener("DOMContentLoaded", function () {
  const storefrontAccessToken = "3c941b69787df45d2ada8becdb851f5e";
  const shopDomain = "kennzeichenexpress.myshopify.com";

  async function fetchAllProducts() {
    console.log("Fetching all products from store...");
    const query = {
      query: `
                {
                    products(first: 250) {
                        edges {
                            node {
                                id
                                title
                                handle
                            }
                        }
                    }
                }
            `,
    };

    try {
      const response = await fetch(
        `https://${shopDomain}/api/2023-10/graphql.json`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token": storefrontAccessToken,
          },
          body: JSON.stringify(query),
        }
      );

      const data = await response.json();
      if (data.data.products.edges.length > 0) {
        console.log(
          `Total products fetched: ${data.data.products.edges.length}`
        );
        return data.data.products.edges.map((edge) => edge.node);
      } else {
        console.warn("No products found in store.");
      }
    } catch (error) {
      console.error("Error fetching all product data:", error);
    }
    return [];
  }

  async function fetchProductMetafields(productId) {
    console.log(`Fetching metafields for product ID: ${productId}`);
    const query = {
      query: `
                {
                    product(id: "gid://shopify/Product/${productId}") {
                        rating: metafield(namespace: "reviews", key: "rating") {
                            value
                        }
                        ratingCount: metafield(namespace: "reviews", key: "rating_count") {
                            value
                        }
                    }
                }
            `,
    };

    try {
      const response = await fetch(
        `https://${shopDomain}/api/2023-10/graphql.json`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token": storefrontAccessToken,
          },
          body: JSON.stringify(query),
        }
      );

      if (!response.ok) {
        console.error(
          `Error fetching metafields: HTTP ${response.status} ${response.statusText}`
        );
        return null;
      }

      const data = await response.json();
      console.log("Metafields API response:", data);

      if (!data || !data.data || !data.data.product) {
        console.warn(`No product data returned for product ID: ${productId}`);
        return null;
      }

      let ratingRaw = data.data.product.rating?.value || "{}";
      let ratingObj = JSON.parse(ratingRaw);
      let ratingValue = ratingObj.value ? parseFloat(ratingObj.value) : 0;
      let ratingCount = parseInt(data.data.product.ratingCount?.value || "0");

      console.log(`Final parsed rating: ${ratingValue}, count: ${ratingCount}`);

      return {
        rating: ratingValue,
        rating_count: ratingCount,
      };
    } catch (error) {
      console.error("Error fetching metafields:", error);
    }
    return null;
  }

  async function injectRatings() {
    console.log("Checking for cross-sell products...");
    const crossSellProducts = document.querySelectorAll(
      ".lb-upsell-product-page-card"
    );

    if (crossSellProducts.length === 0) {
      console.warn("No cross-sell products found on the page.");
      return;
    }

    const allProducts = await fetchAllProducts();

    crossSellProducts.forEach(async (productElement) => {
      if (productElement.dataset.processed) {
        console.log("Skipping already processed product.");
        return;
      }

      let productTitleElement = productElement.querySelector(
        ".lb-spc-details-name"
      );
      if (productTitleElement) {
        let productTitle = productTitleElement.innerText.trim();
        console.log(`Processing product: ${productTitle}`);

        let productData = allProducts.find(
          (p) => p.title.trim() === productTitle
        );

        if (productData) {
          console.log(`Found matching product: ${productData.title}`);
          let metafields = await fetchProductMetafields(
            productData.id.split("/").pop()
          );

          if (metafields && metafields.rating !== undefined) {
            let ratingValue = metafields.rating;
            let ratingCount = metafields.rating_count;

            console.log(
              `Injecting rating: ${ratingValue}, count: ${ratingCount} for ${productTitle}`
            );

            let fullStars = Math.floor(ratingValue);
            let remainingValue = ratingValue - fullStars;
            let halfStar =
              remainingValue >= 0.25 && remainingValue <= 0.75 ? 1 : 0;
            let extraFullStar = remainingValue >= 0.75 ? 1 : 0;
            let emptyStars = 5 - fullStars - halfStar - extraFullStar;

            let ratingHtml = `
    <div class="rating__stars" role="img" aria-label="Rated ${ratingValue} out of 5">
        ${'<svg role="presentation" fill="none" focusable="false" width="15" height="15" class="rating__star" viewBox="0 0 15 15"><path d="M7.5 0L9.58587 5.2731L15 5.72949L10.875 9.44483L12.1353 15L7.5 12.0231L2.86475 15L4.125 9.44483L0 5.72949L5.41414 5.2731L7.5 0Z" fill="currentColor"></path></svg>'.repeat(
          fullStars + extraFullStar
        )}
        ${
          halfStar
            ? '<svg role="presentation" fill="none" focusable="false" width="12" height="12" class="rating__star icon icon-rating-star-half" viewBox="0 0 15 15"><defs><clipPath id="halfStarClip"><rect x="0" y="0" width="7.5" height="15"></rect></clipPath></defs><path d="M7.5 0L9.58587 5.2731L15 5.72949L10.875 9.44483L12.1353 15L7.5 12.0231L2.86475 15L4.125 9.44483L0 5.72949L5.41414 5.2731L7.5 0Z" fill="currentColor" clip-path="url(#halfStarClip)"></path><path d="M7.5 0L9.58587 5.2731L15 5.72949L10.875 9.44483L12.1353 15L7.5 12.0231L2.86475 15L4.125 9.44483L0 5.72949L5.41414 5.2731L7.5 0Z" stroke="currentColor" fill="none"></path></svg>'
            : ""
        }
        ${'<svg role="presentation" fill="none" focusable="false" width="15" height="15" class="rating__star" viewBox="0 0 15 15"><path d="M7.5 0L9.58587 5.2731L15 5.72949L10.875 9.44483L12.1353 15L7.5 12.0231L2.86475 15L4.125 9.44483L0 5.72949L5.41414 5.2731L7.5 0Z" stroke="currentColor" fill="none"></path></svg>'.repeat(
          emptyStars
        )}
         <span style="font-size: 13px;">${ratingValue.toFixed(
           1
         )} (${ratingCount})</span>
    </div>`;

            productTitleElement.insertAdjacentHTML("afterend", ratingHtml);
            productElement.dataset.processed = "true";
            console.log(`Successfully injected rating for ${productTitle}`);
          }
        }
      }
    });
  }

  const style = document.createElement("style");
  style.innerHTML = `
    .rating__stars {
        display: flex;
        align-items: center;
        gap: 2px;
    }
    .rating__star {
        width: 12px;
        height: 12px;
        margin: 4px 0;
    }
    .rating__stars svg {
        display: inline-block;
        vertical-align: middle;
    }
`;
  document.head.appendChild(style);

  injectRatings();

  function observeDOMChanges() {
    const observer = new MutationObserver((mutations) => {
      let newElementsAdded = false;
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (
            node instanceof HTMLElement &&
            node.querySelector(".lb-upsell-product-page-card") &&
            !node.dataset.processed
          ) {
            console.log("New cross-sell product detected, processing...");
            newElementsAdded = true;
          }
        });
      });
      if (newElementsAdded) {
        observer.disconnect();
        injectRatings().then(() => {
          observer.observe(document.body, { childList: true, subtree: true });
        });
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    console.log("MutationObserver is watching for DOM changes...");
  }

  observeDOMChanges();
});
